export const state = {
  roles: [],
  role: {},
  pageCount: 0,
}
